import { ProductPublicModels } from '@features/products/product';

export function getDiscountsPercentages(
    colors: ProductPublicModels.PublicProductColor[],
    colorId: string,
): ProductPublicModels.PublicDiscountsPercentages {
    let discountsPercentages: ProductPublicModels.PublicDiscountsPercentages = {};
    const selectedColor = colors.find(color => color.id === colorId);

    if (selectedColor?.sizes && selectedColor?.sizes.length > 0) {
        discountsPercentages = selectedColor.sizes[0].discountsPercentages;
    } else if (colors?.length > 0 && colors[0]?.sizes && colors[0]?.sizes.length > 0) {
        discountsPercentages = colors[0].sizes[0].discountsPercentages;
    }

    return discountsPercentages;
}
